import { TextProps } from '@slal/ui/typography';
import { StyledText } from './styles';

export interface TextExtendedProps extends TextProps {
    size?: 'sm' | 'md' | 'lg';
}

export const Text = ({ children, size = 'md', ...otherProps }: TextExtendedProps) => (
    <StyledText size={size} {...otherProps}>
        {children}
    </StyledText>
);
